import { c as _c } from "react/compiler-runtime";
import { FilterToolbarClearAll } from "@components/common/faro-table/faro-table-filter/filter-toolbar-clear-all";
import { FilterToolbarQuickSearch } from "@components/common/faro-table/faro-table-filter/filter-toolbar-quick-search";
import { FilterToolbarTitle } from "@components/common/faro-table/faro-table-filter/filter-toolbar-title";
import { Stack } from "@mui-wrapper";
import { useState } from "react";
/** Toolbar to show for filter chips in small screens */
export function FilterToolbarSmallScreen(t0) {
  const $ = _c(14);
  const {
    filterChipComponents
  } = t0;
  const [shouldShowFilterChips, setShouldShowFilterChips] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      justifyContent: "space-between",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      height: "28px",
      alignItems: "center",
      gap: "8px",
      my: "17px",
      justifyContent: "space-between"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== shouldShowFilterChips) {
    t3 = <Stack direction="row" sx={t2}><FilterToolbarTitle shouldShowFilterChips={shouldShowFilterChips} setShouldShowFilterChips={setShouldShowFilterChips} /></Stack>;
    $[2] = shouldShowFilterChips;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FilterToolbarClearAll />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <Stack direction="row" sx={t1}>{t3}{t4}</Stack>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== filterChipComponents || $[8] !== shouldShowFilterChips) {
    t6 = shouldShowFilterChips && <Stack direction="row" sx={{
      justifyContent: "flex-start",
      gap: "2px",
      alignItems: "center",
      flexWrap: "wrap",
      marginBottom: "17px"
    }}>{filterChipComponents}</Stack>;
    $[7] = filterChipComponents;
    $[8] = shouldShowFilterChips;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FilterToolbarQuickSearch />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t6) {
    t8 = <>{t5}{t6}{t7}</>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}